export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/?signup=core',
  RESET_PASSWORD: '/reset-password',
  LOADING: '/loading',
  CONFIRM_EMAIL: '/confirm-email',
  EMAIL_VERIFICATION_SENT: '/email-verification',

  // Authenticated routes
  PROFILE: '/profile',
  PROFILE_USER: '/profile/:userId',
  PROMPTS: '/prompts',
  PROMPTS_WILDCARD: '/prompts/*',
  BUILD_ROOT: '/build',
  BUILD: '/build/contract',
  BUILD_WILDCARD: '/build/*',
  CONTRACTS: '/contracts',
  CONTRACTS_WILDCARD: '/contracts/*',
  CONTRACT_DETAILS: '/contracts/:contractId',
  CONTRACT_SUBMIT_PROPOSAL: '/contracts/:contractId/submit-proposal',
  ADMIN: '/admin',

  // Catch-all
  NOT_FOUND: '*',

  // Settings is now a tab within Profile page
  SETTINGS: '/profile?tab=settings',
};

export const SKIP_AUTH_ROUTES = [
  ROUTES.RESET_PASSWORD,
  ROUTES.CONFIRM_EMAIL,
  ROUTES.EMAIL_VERIFICATION_SENT,
  ROUTES.LOGIN,
];

export const PUBLIC_PATHS = [
  ROUTES.HOME,
  ROUTES.LOGIN,
  ROUTES.LOADING,
  ROUTES.RESET_PASSWORD,
  ROUTES.CONFIRM_EMAIL,
  ROUTES.EMAIL_VERIFICATION_SENT,
];

// Route labels for navigation
export const ROUTE_LABELS = {
  [ROUTES.HOME]: 'Home',
  [ROUTES.LOGIN]: 'Login',
  [ROUTES.PROFILE]: 'Profile',
  [ROUTES.PROMPTS]: 'Prompts',
  [ROUTES.BUILD]: 'Build',
  [ROUTES.CONTRACTS]: 'Contracts',
  [ROUTES.ADMIN]: 'Admin',
  [ROUTES.SETTINGS]: 'Settings',
};

// Session storage keys
export const SESSION_KEYS = {
  // Authentication
  AUTH_TOKEN: 'auth_token',

  // Notifications
  VOLUME: 'gigacore.notificationVolume',
  MUTED: 'gigacore.notificationMuted',
};

export const QUERY_PARAMS = {
  MODE: 'mode',
  RETURN_TO: 'return_to',
  SOURCE: 'source',
  EMAIL: 'email',
  REQUIRES_VERIFICATION: 'requires_verification',
  EMAIL_VERIFIED: 'email_verified',
};

export const QUERY_PARAM_VALUES = {
  SOURCE: {
    LOGIN: 'login',
    SIGNUP: 'signup',
  },
};
